import { fork } from "redux-saga/effects";
import hawkerCentresSaga from "./pages/Centres/saga";
import hawkerStallsSaga from "./pages/Stalls/saga";

export default function* rootSaga() {
  yield fork(hawkerCentresSaga);
  yield fork(hawkerStallsSaga);
}
